import dao from '../../../../dao/smbpartner/financeDao';

const QUERY_STATS = 'pages/partner/finance/withdraw/QUERY_STATS';
const QUERY_STATS_SUCCESS =
  'pages/partner/finance/withdraw/QUERY_STATS_SUCCESS';
const WITHDRAW = 'pages/partner/finance/withdraw/WITHDRAW';
const WITHDRAW_SUCCESS = 'pages/partner/finance/withdraw/WITHDRAW_SUCCESS';

const initialState = {
  amount: '',
  stats: {},
  isLoaded: true,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case QUERY_STATS:
      return {
        ...state,
        isLoaded: false,
      };
    case QUERY_STATS_SUCCESS:
      return {
        ...state,
        stats: {
          ...state.stats,
          ...action.json,
        },
        isLoaded: true,
      };
    case WITHDRAW:
      return {
        ...state,
      };
    case WITHDRAW_SUCCESS:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};

export function queryStats() {
  return dispatch => {
    dispatch({type: QUERY_STATS});
    return dao.queryStats().then(json => {
      return dispatch({type: QUERY_STATS_SUCCESS, json});
    });
  };
}

export function withdraw(params) {
  return dispatch => {
    dispatch({
      type: WITHDRAW,
    });
    return dao.createPayout(params).then(json => {
      dispatch({type: WITHDRAW_SUCCESS, json});
      return json;
    });
  };
}
